export enum AssetStatus {
  approved = 'approved',
  rejected = 'rejected',
  pending = 'pending',
  created = 'created',
  expired = 'expired',
  uploaded = 'uploaded',
  awaiting_approval = 'awaiting_approval',
  import = 'import',
  failed = 'failed',
  archived = 'archived',
  draft = 'draft',
}
